import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class CryptNoble1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CRYPT_NOBLE1;
}

export default CryptNoble1PoiTileEntity;
